var _circle, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTiktokRound(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 32,
    fill: "#a6fa9f"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#A)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.076 27.722v5.953l-.412-.041c-2.758-.55-5.427 1.354-5.817 4.155-.401 2.864 1.601 5.542 4.316 5.77 2.953.25 5.407-1.932 5.42-4.916l.013-22.835v-.802h5.787c.371 5.053 3.263 7.613 7.983 8.317v5.798c-2.898-.013-5.456-.965-7.896-2.634-.013.27-.03.47-.03.669l-.006 11.419c-.034 5.368-3.698 9.895-8.834 10.797-4.044.711-7.507-.556-10.129-3.784-2.671-3.286-3.231-7.05-1.724-11.04 1.743-4.614 6.329-7.404 11.116-6.883.053.004.106.026.212.056z",
    fill: "#222"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "A"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(17.92 15.003)",
    d: "M0 0h29.44v34.56H0z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTiktokRound);
export default __webpack_public_path__ + "static/media/tiktok_round.e4fe35d69503fcb218a1edc768b967ef.svg";
export { ForwardRef as ReactComponent };